module.exports = __webpack_public_path__ + "img/no_data.c771572b.jpg";